




























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import SupplierPO from "@/store/entities/customer/supplierpo";
@Component
export default class EditSupplier extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  supplier: SupplierPO = new SupplierPO();
  created() {}
  save() {
    (this.$refs.itemForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "supplier/update",
          data: this.supplier,
        });
        (this.$refs.itemForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.itemForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.supplier = Util.extend(true, {}, this.$store.state.supplier.supplierItems);
    }
  }
  itemRule = {
    name: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    enCode:[
         {
        required: true,
         message: this.L("Encode") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
}
